//Roles
import { ADMIN, REQUERIMIENTO, SUP, MAQ, MEC, ADMINNOABM, SOCIO, CANCHERO, GESTOR_RESERVAS, REV, REVISOR_RESERVAS} from './roles'

//Habilitados para ver solapa nav de productos.
export const VER_PRODUCTOS = [ADMIN];
//Habilitados para ver todos los requerimientos de la lista y no solo los que fueron creados por el usuario.
export const VER_TODOS_REQUERIMIENTOS = [ADMIN];
//Habilitados para modificar el estado de autorización de un requerimiento.
export const MODIFICAR_ESTADO_REQUERIMIENTO = [ADMIN];
//Habilitados para editar notas privadas de un requerimiento ya creado.
export const EDITAR_NOTAS_PRIVADAS = [ADMIN];
//Habilitados para editar notas publicas de un requerimiento ya creado.
export const EDITAR_NOTAR_PUBLICAS = [ADMIN];
//Habilitados para usar la pantalla de edición de un requerimiento ya creado.
export const EDITAR_REQUERIMIENTO = [ADMIN];
//Habilitados para ver solapa nav de usuario.
export const VER_USUARIOS = [ADMIN];
//Habilitados para reenviar un requerimiento desde la lista de requerimientos.
export const REENVIO_YARAVI = [ADMIN];
//Habilitados para ver solapa Tablero de Activos
export const VER_TABACTIVOS = [ADMIN];
//Habilitados para ver solapa Tablero de Activos
export const VER_TABACTIVOSSUPERVISOR = [SUP, REV];
//Habilitados para ver solapa Tablero de Activos
export const VER_PROCSPROGRAMADOS = [SUP,ADMIN,ADMINNOABM];
//Es Maquinista...
export const IS_MACHINISTIC = [MAQ];
//Es mecánico...
export const IS_MECHANIC = [MEC];
//Es solo revisor...
export const IS_REVISOR = [REV];

//Habilitados para ver solapa nav de productos.
export const VER_ABMS = [ADMIN];

export const VER_GRUPOS = [ADMIN];

export const IS_ADMIN = [ADMIN];

//Admin with or without ABMs
export const IS_ADMINWORWTHABMS = [ADMIN, ADMINNOABM];

//Es Socio
export const IS_SOCIO = [SOCIO];

//Es Canchero (solo lectura de Grilla Disponibilidad)
export const IS_CANCHERO = [CANCHERO];

//Es Gestor de Reservas
export const IS_GESTOR_RESERVAS = [GESTOR_RESERVAS];

//Es Revisor de Reservas (solo ve Reservas de Canchas)
export const IS_REVISOR_RESERVAS = [REVISOR_RESERVAS];
